module.exports = __webpack_public_path__ + "static/avatar-b4e9fdc4bf101a0ab8604c809b03272e.jpg";